import { useEffect } from 'react';
const SwitchTheme = () => {
   const switchTheme = () => {
      const theme = localStorage.getItem('theme');
      localStorage.setItem('theme', theme === 'light' ? 'dark' : 'light');
      if (theme === 'light') {
         document.documentElement.classList.add('dark');
      } else {
         document.documentElement.classList.remove('dark');
      }
   };
   useEffect(() => {
      const theme = localStorage.getItem('theme');
      const isSystemLight = window.matchMedia(
         '(prefers-color-scheme: light)',
      ).matches;
      const newTheme = ['dark', 'light'].includes(theme)
         ? theme
         : isSystemLight
         ? 'light'
         : 'dark';
      if (newTheme === 'dark') {
         document.documentElement.classList.add('dark');
      }
   }, []);
   return (
      <button
         className='flex p-[4px] h-[40px] bg-[#E4E9ED] outline-none cursor-pointer dark:bg-[#201F1F] rounded-[20px]'
         onClick={switchTheme}
      >
         <div className='h-[32px] dark:shadow-[0px_1px_2px_0px_#00000008,_0px_3px_5px_0px_#0000000D] w-[44px] rounded-[16px] bg-[#ffffff] dark:bg-transparent flex items-center justify-center'>
            <svg
               className='inline-block dark:hidden'
               fill='none'
               height='20'
               viewBox='0 0 20 20'
               width='20'
            >
               <path
                  d='M9.99984 15.8333C13.2215 15.8333 15.8332 13.2217 15.8332 10C15.8332 6.77834 13.2215 4.16667 9.99984 4.16667C6.77818 4.16667 4.1665 6.77834 4.1665 10C4.1665 13.2217 6.77818 15.8333 9.99984 15.8333Z'
                  fill='#292B32'
               />
               <path
                  d='M10.0002 19.1333C9.54183 19.1333 9.16683 18.7917 9.16683 18.3333V18.2667C9.16683 17.8083 9.54183 17.4333 10.0002 17.4333C10.4585 17.4333 10.8335 17.8083 10.8335 18.2667C10.8335 18.725 10.4585 19.1333 10.0002 19.1333ZM15.9502 16.7833C15.7335 16.7833 15.5252 16.7 15.3585 16.5417L15.2502 16.4333C14.9252 16.1083 14.9252 15.5833 15.2502 15.2583C15.5752 14.9333 16.1002 14.9333 16.4252 15.2583L16.5335 15.3667C16.8585 15.6917 16.8585 16.2167 16.5335 16.5417C16.3752 16.7 16.1668 16.7833 15.9502 16.7833ZM4.05016 16.7833C3.8335 16.7833 3.62516 16.7 3.4585 16.5417C3.1335 16.2167 3.1335 15.6917 3.4585 15.3667L3.56683 15.2583C3.89183 14.9333 4.41683 14.9333 4.74183 15.2583C5.06683 15.5833 5.06683 16.1083 4.74183 16.4333L4.6335 16.5417C4.47516 16.7 4.2585 16.7833 4.05016 16.7833ZM18.3335 10.8333H18.2668C17.8085 10.8333 17.4335 10.4583 17.4335 10C17.4335 9.54167 17.8085 9.16667 18.2668 9.16667C18.7252 9.16667 19.1335 9.54167 19.1335 10C19.1335 10.4583 18.7918 10.8333 18.3335 10.8333ZM1.7335 10.8333H1.66683C1.2085 10.8333 0.833496 10.4583 0.833496 10C0.833496 9.54167 1.2085 9.16667 1.66683 9.16667C2.12516 9.16667 2.5335 9.54167 2.5335 10C2.5335 10.4583 2.19183 10.8333 1.7335 10.8333ZM15.8418 4.99167C15.6252 4.99167 15.4168 4.90833 15.2502 4.75C14.9252 4.425 14.9252 3.9 15.2502 3.575L15.3585 3.46667C15.6835 3.14167 16.2085 3.14167 16.5335 3.46667C16.8585 3.79167 16.8585 4.31667 16.5335 4.64167L16.4252 4.75C16.2668 4.90833 16.0585 4.99167 15.8418 4.99167ZM4.1585 4.99167C3.94183 4.99167 3.7335 4.90833 3.56683 4.75L3.4585 4.63333C3.1335 4.30833 3.1335 3.78333 3.4585 3.45833C3.7835 3.13333 4.3085 3.13333 4.6335 3.45833L4.74183 3.56667C5.06683 3.89167 5.06683 4.41667 4.74183 4.74167C4.5835 4.90833 4.36683 4.99167 4.1585 4.99167ZM10.0002 2.53333C9.54183 2.53333 9.16683 2.19167 9.16683 1.73333V1.66667C9.16683 1.20833 9.54183 0.833333 10.0002 0.833333C10.4585 0.833333 10.8335 1.20833 10.8335 1.66667C10.8335 2.125 10.4585 2.53333 10.0002 2.53333Z'
                  fill='#292B32'
               />
            </svg>
            <svg
               className='hidden dark:inline-block'
               fill='none'
               height='20'
               viewBox='0 0 20 20'
               width='20'
            >
               <path
                  d='M9.99992 15.4167C12.9915 15.4167 15.4166 12.9915 15.4166 10C15.4166 7.00846 12.9915 4.58333 9.99992 4.58333C7.00838 4.58333 4.58325 7.00846 4.58325 10C4.58325 12.9915 7.00838 15.4167 9.99992 15.4167Z'
                  stroke='#908F8F'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
               />
               <path
                  d='M15.9501 15.95L15.8417 15.8417M15.8417 4.15833L15.9501 4.05L15.8417 4.15833ZM4.05008 15.95L4.15841 15.8417L4.05008 15.95ZM10.0001 1.73333V1.66667V1.73333ZM10.0001 18.3333V18.2667V18.3333ZM1.73341 10H1.66675H1.73341ZM18.3334 10H18.2667H18.3334ZM4.15841 4.15833L4.05008 4.05L4.15841 4.15833Z'
                  stroke='#908F8F'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
               />
            </svg>
         </div>
         <div className='h-[32px] dark:shadow-[0px_1px_2px_0px_#00000008,_0px_3px_5px_0px_#0000000D] w-[44px] rounded-[16px] ml-[4px] bg-transparent dark:bg-[#2E2D2D] flex items-center justify-center'>
            <svg
               className='inline-block dark:hidden'
               fill='none'
               height='20'
               viewBox='0 0 20 20'
               width='20'
            >
               <path
                  d='M1.69158 10.35C1.99158 14.6417 5.63325 18.1333 9.99158 18.325C13.0666 18.4583 15.8166 17.025 17.4666 14.7667C18.1499 13.8417 17.7832 13.225 16.6416 13.4333C16.0832 13.5333 15.5082 13.575 14.9082 13.55C10.8332 13.3833 7.49991 9.975 7.48325 5.95C7.47491 4.86667 7.69991 3.84167 8.10825 2.90833C8.55825 1.875 8.01658 1.38333 6.97491 1.825C3.67491 3.21667 1.41658 6.54167 1.69158 10.35Z'
                  stroke='#79889B'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
               />
            </svg>
            <svg
               className='hidden dark:inline-block'
               fill='none'
               height='20'
               viewBox='0 0 20 20'
               width='20'
            >
               <path
                  d='M17.9417 13.275C17.8083 13.05 17.4333 12.7 16.5 12.8667C15.9833 12.9583 15.4583 13 14.9333 12.975C12.9917 12.8917 11.2333 12 10.0083 10.625C8.925 9.41667 8.25833 7.84167 8.25 6.14167C8.25 5.19167 8.43333 4.275 8.80833 3.40833C9.175 2.56667 8.91667 2.125 8.73333 1.94167C8.54167 1.75 8.09167 1.48333 7.20833 1.85C3.8 3.28333 1.69167 6.7 1.94167 10.3583C2.19167 13.8 4.60833 16.7417 7.80833 17.85C8.575 18.1167 9.38333 18.275 10.2167 18.3083C10.35 18.3167 10.4833 18.325 10.6167 18.325C13.4083 18.325 16.025 17.0083 17.675 14.7667C18.2333 13.9917 18.0833 13.5 17.9417 13.275Z'
                  fill='white'
               />
            </svg>
         </div>
      </button>
   );
};
export default SwitchTheme;
